import { useQuery } from '@tanstack/react-query';
import { checkRewardStatus } from '~/api';
import { RewardState } from '~/types';
import dartKey from './dartKey';

const useRewardStatusQuery = () => {
  const timezone_iana = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: dartKey.getRewardStatus(),
    queryFn: async () => {
      const { data, status } = await checkRewardStatus({
        timezone_iana,
      });
      if (status === 200) {
        return data as RewardState;
      }
      throw new Error('Failed to get reward status');
    },
  });
};

export default useRewardStatusQuery;
